export default __webpack_public_path__ + "static/media/fundingCash.24ef13d6.svg";